if (window.innerWidth < 750) {
    
    const productContentsSwiper = new Swiper(".product-contents .swiper-container", {
        direction: 'horizontal',
        loop: true,
        pagination: {
          el: ".product-contents .swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".product-contents .swiper-button-next",
          prevEl: ".product-contents .swiper-button-prev",
        },
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 10,
        centeredSlides: true,
      });

}